import React from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const Navbar = () => {
  const { user, logout } = useAuth();

  return (
    <nav className="navbar">
      <Link to="/tasks" className="navbar-brand">
        <img src="/logo.png" alt="Thor Hammer" style={{ width: '32px', height: '32px', marginRight: '10px', verticalAlign: 'middle' }} />
        Thor Hammer
      </Link>

      <ul className="navbar-nav">
        <li><Link to="/tasks">Tasks</Link></li>
        <li><Link to="/kanban">Board</Link></li>
        <li><Link to="/dashboard">Dashboard</Link></li>
        <li><Link to="/jobs">My Jobs</Link></li>
        {user?.is_admin && <li><Link to="/admin">Admin</Link></li>}
      </ul>

      <div className="navbar-user">
        <span>👤 {user?.username}</span>
        {user?.is_admin && <span className="badge">Admin</span>}
        <button onClick={logout} className="btn-logout">Logout</button>
      </div>
    </nav>
  );
};

export default Navbar;
